var React = require('react');

var Input = require('./index.js');

var css = require('./module.scss');


var InputUnit = React.createClass({

    getInitialState: function () {
        return {
        };
    },


    componentDidUpdate: function () { },

    onChange: function (e) {
        var value = e.target.value;
        var dataType = this.props.dataType;
        if (dataType === 'money') {
            if (value !== '' && !('' + value).match(/((^[1-9]\d*)|^0)(\.\d{0,2}){0,1}$/g)) {
                return;
            }
        } else if (dataType === 'amount') {
            if (value !== '' && !('' + value).match(/^(?:[0-9]|[1-8][0-9]|90)$/)) {
                return;
            }
        }else if (dataType === 'discount') {
            if (value !== '' && !('' + value).match(/^(0\.\d+|[1-9][0-9]|1)$/g)) {
                return;
            }
        } else if (dataType === 'hour') {
            if (value !== '' && !('' + value).match(/((^[1-9]\d*)|^0)(\.\d{0,1}){0,1}$/g)) {
                return;
            }
        }else if (dataType === 'no') {//只能输入数字和英文
            if (value !== '' && !('' + value).match(/^[0-9a-zA-Z]*$/g)) {
                return;
            }
        }
        this.props.onChange && this.props.onChange(e);
    },

    onMoreChange: function (value) {
        this.props.onMoreChange && this.props.onMoreChange(value);
    },

    render: function () {
        var _this = this;
        var phs = this.props.placeholder ? this.props.placeholder.split('|') : [];
        return (
            <div className='fp-input-unit'>
                <Input
                    ref={this.props.name}
                    name={this.props.name}
                    value={this.props.value}
                    onChange={this.onChange.bind(this)}
                    placeholder={phs[0]}
                    size={this.props.size}
                    wtype={this.props.wtype}
                    disabled={this.props.disabled}
                    reg={this.props.reg}
                    dataType={this.props.dataType}
                />
                {
                    this.props.unit && this.props.more ? (
                        <span className='fp-input-unit-text'>{this.props.unit}</span>
                    ) : null
                }
                {
                    this.props.more ? (
                        <span className='fp-input-more-text'>至</span>
                    ) : null
                }
                {
                    this.props.more ? (
                        <Input
                            ref={this.props.more}
                            name={this.props.more}
                            value={this.props.moreValue}
                            onChange={this.onMoreChange.bind(this)}
                            placeholder={phs[1]}
                            size={this.props.size}
                            wtype={this.props.wtype}
                            disabled={this.props.disabled}
                        />
                    ) : null
                }
                {
                    this.props.unit ? (
                        <span className='fp-input-unit-text'>{this.props.unit}</span>
                    ) : null
                }
            </div>
        );
    }

});

module.exports = InputUnit;



// WEBPACK FOOTER //
// ./component/input/unit.js